import { useAuth } from '../../../hooks';
import { useTracking } from '../../../hooks/useTracking';
import useRegisterPost from '../../../api/register/mutations/useRegisterPost';
import { useLocationGeocoding } from './useLocationGeocoding';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSignUpIdentity } from '../../../hooks/useSignUpIdentity';
import { useEffect, useState } from 'react';
import { useBreakpointValue } from '@chakra-ui/react';
import { Address, LocationStep } from '../types';

const TRACK_ADDRESS_COLLECTION = 'address_collection';

export const useLocationView = () => {
  const navigate = useNavigate();
  const { state, search } = useLocation();
  const { track } = useTracking();
  const { mutation } = useRegisterPost();
  const { isAuthenticated, loading, user } = useAuth();
  const signUpIdentity = useSignUpIdentity();

  const [locationInputValue, setLocationInputValue] = useState('');
  const [selectedLocation, setSelectedLocation] = useState();
  const [address, setAddress] = useState<Address>();
  const [currentLocationStep, setCurrentLocationStep] =
    useState<LocationStep>('geosuggest');

  const parsedAddress = useLocationGeocoding(selectedLocation);

  useEffect(() => {
    track(TRACK_ADDRESS_COLLECTION, null);
  }, [track]);

  useEffect(() => {
    if (!parsedAddress) return;

    setAddress(parsedAddress);
  }, [parsedAddress]);

  useEffect(() => {
    if (!loading && isAuthenticated && !!user) {
      const {
        address_city: city,
        address_state: state,
        address_street: street,
        address_zip: zip,
      } = user;

      if (city || state || street || zip) {
        setAddress({ city, state, street, zip });
        setCurrentLocationStep('form');
      }
    }
  }, [isAuthenticated, loading, user]);

  const isMobile = useBreakpointValue({
    base: true,
    lg: false,
  });

  const onLocationSelect = (location: any) => {
    setSelectedLocation(location);
    setCurrentLocationStep('form');
  };

  const onSave = async ({
    street,
    city,
    state: addressState,
    zip,
  }: Address) => {
    await mutation.mutateAsync({
      referrer: state?.referrer,
      affiliate: state?.affiliate,
      email: signUpIdentity.email,
      street,
      city,
      state: addressState,
      zip,
    });

    navigate(`/phone${search}`, { state: { ...state, ...signUpIdentity } });
  };

  return {
    address,
    currentLocationStep,
    error: mutation.isError,
    isMobile,
    loading,
    locationInputValue,
    onLocationSelect,
    onSave,
    selectedLocation,
    setAddress,
    setCurrentLocationStep,
    setLocationInputValue,
  };
};
